import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import uuid from 'uuid';
import { useAnalyticsEvents } from '../../../common/analytics/generated/use-analytics-events';
import * as measure from '../../../utils/performance';
import { useSmartCardActions } from '../../actions';
import { getDefinitionId, getExtensionKey, getResourceType } from '../../helpers';
import { useSmartCardState } from '../../store';
import { useScheduledRegister } from './useScheduledRegister';
var useResolveHyperlink = function useResolveHyperlink(_ref) {
  var href = _ref.href;
  var _useState = useState(function () {
      return uuid();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var state = useSmartCardState(href);
  var definitionId = getDefinitionId(state.details);
  var extensionKey = getExtensionKey(state.details);
  var resourceType = getResourceType(state.details);
  var actions = useSmartCardActions(id, href);
  var scheduledRegister = useScheduledRegister(href, actions.register);
  var _useAnalyticsEvents = useAnalyticsEvents(),
    fireEvent = _useAnalyticsEvents.fireEvent;
  useEffect(function () {
    scheduledRegister().catch(function (error) {
      throw error;
    });
  }, [scheduledRegister]);
  useEffect(function () {
    measure.mark(id, state.status);
    if (state.status !== 'pending' && state.status !== 'resolving') {
      var _state$error, _state$error2;
      measure.create(id, state.status);
      if (state.status === 'resolved') {
        var _measure$getMeasure$d, _measure$getMeasure;
        fireEvent('operational.hyperlink.resolved', {
          definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
          extensionKey: extensionKey !== null && extensionKey !== void 0 ? extensionKey : null,
          resourceType: resourceType !== null && resourceType !== void 0 ? resourceType : null,
          duration: (_measure$getMeasure$d = (_measure$getMeasure = measure.getMeasure(id, state.status)) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) !== null && _measure$getMeasure$d !== void 0 ? _measure$getMeasure$d : null
        });
      } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError') {
        fireEvent('operational.hyperlink.unresolved', {
          definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
          extensionKey: extensionKey !== null && extensionKey !== void 0 ? extensionKey : null,
          resourceType: resourceType !== null && resourceType !== void 0 ? resourceType : null,
          reason: state.status,
          error: state.error === undefined ? null : {
            name: state.error.name,
            kind: state.error.kind,
            type: state.error.type
          }
        });
      }
    }
  }, [id, state.status, state.error, definitionId, extensionKey, resourceType, fireEvent]);
  return {
    state: state,
    actions: actions
  };
};
export default useResolveHyperlink;